import { useTranslation } from 'react-i18next';
import { ColorNordicGrey4 } from 'autogen/design-tokens/tokens';
import type { ProductPageViewModel } from 'autogen/swagger/all';
import { CustomerReviews } from 'autogen/translation-keys/trans-website-productreview-list';
import Layout from 'components/Layout';
import Reviews from 'components/reviews/reviews';
import WhenSplitTestVariant from 'helpers/WhenSplitTestVariant';
import CustomMediaContent from './components/CustomMediaContent';
import Flowbox from './components/Flowbox';
import ProductInformation from './components/ProductInformation';
import StyledProductRecommendationLoader from './shared/styles';

export type DysonProductPageProps = {
    model: ProductPageViewModel;
};

export default function DysonProductPage(props: DysonProductPageProps) {
    const { model } = props;
    const { productInformation, recommendationRequest, reviews, emaLogo, flowBoxModel, canSmartBundleBeRequested } =
        model;
    const { t } = useTranslation();

    return (
        <Layout.Page>
            {/* Product Information */}
            <Layout.Section>
                <ProductInformation
                    productInformation={productInformation}
                    emaLogo={emaLogo}
                    canSmartBundleBeRequested={canSmartBundleBeRequested}
                />
            </Layout.Section>

            {/* Dyson specifications */}
            {productInformation.customMediaContent.length > 0 && (
                <Layout.Section>
                    <CustomMediaContent customMediaContent={productInformation.customMediaContent} />
                </Layout.Section>
            )}

            {/* Flowbox - User Generated Content */}
            {flowBoxModel && (
                <Layout.Section>
                    <Flowbox model={flowBoxModel} productId={productInformation.productId} />
                </Layout.Section>
            )}

            {/* Product Recommendation */}
            {recommendationRequest && (
                <Layout.Section>
                    <StyledProductRecommendationLoader model={recommendationRequest?.recommendationRequest} />
                </Layout.Section>
            )}

            {/* Product Reviews */}
            {reviews.reviews && (
                <Layout.Section.WithFullWidthBackground backgroundColor={ColorNordicGrey4} heading={t(CustomerReviews)}>
                    <Reviews model={reviews.reviews} />
                </Layout.Section.WithFullWidthBackground>
            )}
        </Layout.Page>
    );
}
